import React from "react";

function AboutIntro() {
  return (
    <div className="about-intro">
      <p>
        Hola, I'm Carlos! I first joined the circus through social work back in
        my home country, Colombia, bringing culture to communities impacted by
        the civil war.
        <br></br>
        <br></br>
        At 18, I set out across South America as a street artist moving through
        Colombia, Ecuador, Peru, Chile, Argentina, and Brazil. I threw myself
        into the continent's circus scene, taking workshops at circus schools,
        performing in the streets and festivals, and connecting with an enormous
        range of local and international artists along the way. This constant
        exchange of skills, ideas, and friendship became the foundation of my
        artistic practice before I made the move to Europe in 2020.
        <br></br>
        <br></br>
        Now based in Sweden, I'm a circus artist specializing in juggling and
        tall unicycle, pushing these traditions into the language of
        contemporary circus. Since moving to Europe, I've been exploring the
        intersection of live performance and technology through collaborating
        with artists to integrate light shows, projection mapping, video
        feedback, and programmable LED into my work. The tools are new, but the
        approach is the same: building through exchange, experimenting together,
        and finding new ways to connect with audiences.
      </p>
      <p>
        <br></br>
        {/* From Colombia
      Travelled South America as a street artistis
      Empiric
      Amsterdam
      Malmö
      Cirkusskola */}
      </p>
      <p></p>
      <p></p>
    </div>
  );
}

export default AboutIntro;
